/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

export const UPSELL_OPTIONS = [
  "2905",
  "BALLROOM",
  "CATERING",
  "DBL",
  "DPDP",
  "ECO",
  "ICITEZ",
  "JSUI",
  "PM",
  "PSUI",
  "ROYAL",
  "SGL",
  "SUI",
  "SUP",
  "TESTK",
  "TESTKI",
  "VSUI",
];

export const PROFILE_OPTIONS = [
  { id: 1, label: "Beacon Grand", value: "beacon" },
  { id: 2, label: "Opera Sandbox", value: "sandbox" },
];
